<template>
  <component :is="componentName" :model="model" />
</template>
<script>
import TabsSubpage from './ContentType.TabsSubPage'
import TabsHtml from './ContentType.TabsHtml'
import { TabsModes } from '../../../models/enums'
export default {
  name: 'Tabs',
  components: {
    TabsSubpage,
    TabsHtml
  },
  props: ['model'],
  computed: {
    componentName: function () {
      var name
      switch (this.model.metadata.mode) {
        case TabsModes.HtmlContent:
          name = 'tabs-html'
          break
        default:
          name = 'tabs-subpage'
          break
      }
      return name
    }
  }
}
</script>
